import { Button, Drawer, TextField } from "@mui/material";
import { ChangeEventHandler, useState } from "react";
import { authStore } from "../../App";
import { createUserWithEmailAndPassword } from "@firebase/auth";
import { auth } from "../../firebase";

const RegisterDialog: React.FC = () => {
  const [openRegister, setOpenRegister] = useState(false);

  //Email
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  //Password
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const register = () => {
    createUserWithEmailAndPassword(auth, email, password)
      .then(() => {})
      .catch((e) => {});
  };

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const passwordRegext =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  const handleEmailChange = (value: string) => {
    const newEmail = value;
    setEmail(newEmail);

    // Validate the email as the user types
    if (newEmail === "") {
      setEmailError("Email is required.");
    } else if (!emailRegex.test(newEmail)) {
      setEmailError("Please enter a valid email address.");
    } else {
      // Clear the error if the email is valid
      setEmailError("");
    }
  };

  const handlePasswordChange = (value: string) => {
    const newPassword = value;
    setPassword(newPassword);

    // Validate the email as the user types
    if (newPassword === "") {
      setPasswordError("Password is required.");
    } else if (!passwordRegext.test(newPassword)) {
      setPasswordError("Please enter a valid Password.");
    } else {
      // Clear the error if the email is valid
      setPasswordError("");
    }
  };

  return (
    <div>
      <Button onClick={() => setOpenRegister(true)}>Register</Button>
      <Drawer open={openRegister} onClose={() => setOpenRegister(false)}>
        <div
          style={{
            display: "flex",
            flexFlow: "column",
            padding: 50,
            width: 450,
            columnGap: 10,
            rowGap: 20,
            textAlign: "center",
          }}
        >
          <h1>Register</h1>

          <div></div>
          <div style={{ display: "flex", flexFlow: "column" }}>
            <TextField
              required
              id="outlined-required"
              label="Email"
              defaultValue="riaz@gmail.com"
              onChange={(e) => handleEmailChange(e.target.value)}
            />
            {emailError && (
              <div style={{ color: "red", marginTop: "5px" }}>{emailError}</div>
            )}
          </div>
          <div style={{ display: "flex", flexFlow: "column" }}>
            <TextField
              required
              id="outlined-required"
              label="Password"
              defaultValue="Huambo#1995"
              type="password"
              onChange={(e) => handlePasswordChange(e.target.value)}
            />
            {passwordError && (
              <div style={{ color: "red", marginTop: "5px" }}>
                {passwordError}
              </div>
            )}
          </div>
          <div style={{ display: "flex", flexFlow: "column" }}>
            <p style={{ fontSize: "small" }}>
              By clicking the <b>Register</b> button you agree to our Partner
              Program's Terms of Use and have read our Community Guidelines,
            </p>
            <Button
              variant="contained"
              color="success"
              onClick={() => {
                authStore.signUp(email, password);
              }}
            >
              Register
            </Button>
            <Button
              onClick={() => {
                authStore.signUp(email, password);
              }}
            >
              Cancel
            </Button>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export { RegisterDialog };
